export function htmlToString(content: string | TrustedHTML | undefined): string {
    if (content === undefined || content === null) {
        return '';
    }
    const div = document.createElement('div');
    div.innerHTML = String(content);
    return div.textContent ?? "";
}